<script lang="ts">
  import { LoaderCircle } from '@lucide/svelte'
  import i18n from '../../i18n'
  import { logoDarkFull, logoLightFull } from '../../assets/images'
</script>

<div class="auth-loading-screen" data-testid="auth-loading-screen">
  <img
    class="dark-hidden"
    alt={$i18n.t('authLayout.logoAlt')}
    src={logoLightFull}
  />
  <img
    class="light-hidden"
    alt={$i18n.t('authLayout.logoAlt')}
    src={logoDarkFull}
  />
  <div class="status">
    <LoaderCircle class="spin" color="var(--primary)" size="1.25rem" />
    <span>{$i18n.t('auth.checkingSession')}</span>
  </div>
</div>

<style lang="scss">
  .auth-loading-screen {
    align-items: center;
    background: var(--background);
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: 100vh;
    justify-content: center;
    inset: 0;
    position: fixed;
    width: 100vw;
    z-index: 1000;

    img {
      max-width: 12rem;
    }

    .status {
      align-items: center;
      color: var(--text-secondary);
      display: flex;
      flex-direction: row;
      font-size: 0.875rem;
      gap: 0.5rem;

      :global(.spin) {
        animation: spin 1s linear infinite;
      }
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
